import { useState } from "react";

const ProfileChangeRealName = ({ successIcon, failIcon, close, onUpdateRealName }) => {

  const [step, setStep] = useState("start");
  const [name, setName] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const getIsDisabled = () => {
    if (isLoading) {
      return true
    } else if (name.trim().length < 1) {
      return true
    } else {
      return false
    }
  }

  const handleInputChange = (e) => {
    let inputName = e.target.value;

    if (inputName.length > 50) {
      inputName = inputName.slice(0, 50);
    }

    const cleanedName = inputName.replace(/[^A-Za-zА-Яа-яЁё\s]/g, '');

    const capitalizedWords = cleanedName
      .split(/\s+/)
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');

    setName(capitalizedWords);
  };

  const submitHandler = async () => {
    onUpdateRealName(name, setStep, setIsLoading)
  };

  return (
    <section className="profile-change__popup">
      {step === "start" && (
        <>
          <h2 className="modal-window__title">Change Real Name</h2>
          <form className="profile-change__form">
            <p className="profile-change__row">
              <label htmlFor="name">Enter New Name</label>
              <input
                type="text"
                id="name"
                onInput={handleInputChange}
                value={name}
                placeholder="Your name"
                autoFocus
              />
            </p>
            <button
              type="button"
              className="profile-change__form-submit"
              disabled={getIsDisabled()}
              onClick={submitHandler}
            >
              Continue
            </button>
          </form>
        </>
      )}

      {step === "success" && (
        <>
          <header className="modal-window__header">
            <img src={successIcon} className="modal-window__icon" alt="" />
            <h5 className="modal-window__title">Success!</h5>
            <p className="modal-window__info">
              Your real name was updated successfully!
            </p>
          </header>
          <footer className="modal-window__footer">
            <button className="modal-window__footer-submit" onClick={close}>
              Done
            </button>
          </footer>
        </>
      )}

      {step === "fail" && (
        <>
          <header className="modal-window__header">
            <img src={failIcon} className="modal-window__icon" alt="" />
            <h5 className="modal-window__title">Something went wrong</h5>
            <p className="modal-window__info">Please, try again later</p>
          </header>
          <footer className="modal-window__footer">
            <button className="modal-window__footer-submit" onClick={close}>
              Done
            </button>
          </footer>
        </>
      )}
    </section>
  );
};

export default ProfileChangeRealName;
